<template>
    <div>
        <div class="form-group bmd-form-group search-area m-0 mb-2">
            <div class="row">
                <div class="col-lg-4 col-md-6 col-12 d-inline-block mt-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">دسته بندی :</span>
                        </div>
                        <vs-select :data="categories" :mode="'create'"
                                   :header="{multiple: false, label: 'name'}"
                                   @onChange="onSelectCategory"></vs-select>
                    </div>
                </div>
                <div class="col-lg-3 col-md-5 col-12 m-2">
                    <div class="input-group">
                        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fa fa-search"></i>
                    </span>
                        </div>
                        <input type="text" class="form-control" placeholder="جستجو..." @input="onSearchInput" ref="searchInput" @keyup.enter="onModalShow"
                               v-model="searchString">
                        <button type="button" class="d-inline-block btn btn-info mx-2 barcode"
                                @click="openBarcode"><i
                                class="fa fa-camera"></i></button>
                    </div>
                </div>

                <div class="col-lg-4 col-md-11 col-12 text-center m-2">
                    <button class="btn btn-primary mx-1" @click="onModalButtonClick">افزودن محصول جدید</button>
                    <button class="btn btn-primary mx-1" @click="onModalShow">مشاهده فاکتور</button>
                    <button class="btn btn-danger" @click="onReturn" v-if="!fromEdit">ثبت مرجوعی</button>
                </div>
            </div>


        </div>
        <div class="row" v-if="listView">
            <!--<div class="col-lg-12 mt-3 mb-1">
                <div class="category-item" v-for="item in categories">
                    <h4>{{item.name}}</h4>
                </div>
            </div>-->
            <div class="col-lg-8 offset-lg-2" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0}" class="card list" @click="onCardClicked($event, index)">
                    <div class="row">
                        <div class="col-md-4">
                            <strong>{{item.productName}}</strong>
                        </div>
                        <div class="col-md-4">
                            <span>موجودی: </span>
                            <span>{{item.stock}} {{item.unitName}}</span>
                        </div>
                        <div class="col-md-2">
                            <span>تعداد: </span>
                            <span v-if="item.unitVal === undefined || item.unitVal === ''">0</span>
                            <span v-else>{{item.unitVal}}</span>
                        </div>
                        <div class="col-md-4">
                            <span>قیمت: </span>
                            <span>{{item.price == null ? 0 :item.price.toLocaleString()}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <div class="col-lg-4 col-sm-6 product-container" v-for="(item, index) in products">
                <div :class="{active: item.unitVal > 0}" class="card product mt-2 mb-2"
                     @click="onCardClicked($event, index)">
                    <div class="row p-2">
                        <div class="col-8">
                            <h5>{{item.productName}}</h5>
                            <span>موجودی انبار:</span>
                            <span>{{item.stock}} {{item.unitName}}</span>
                            <br>
                            <span>قیمت:</span>
                            <span>{{item.price == null ? 0 : item.price.toLocaleString()}}</span>
                            <br>
                            <span>تعداد:</span>
                            <span v-if="item.unitVal === undefined || item.unitVal === ''">0</span>
                            <span v-else>{{item.unitVal}}</span>
                            <br>
                            <span>بارکد:</span>
                            <span>{{item.barcode}}</span>
                        </div>
                        <div class="col-4">
                            <img class="view-image" :src="item.imageAddress!==null && item.imageAddress !='' ? validateImageUrl(item.imageAddress) :noImageUrl()">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12 mt-5 text-center" v-if="products !== undefined && products.length < 1">
                <h3 class="no-item-alert">محصولی یافت نشد!</h3>
            </div>
            <div class="col-lg-12 mt-5"
                 :style="[autoload && products.length < dataCount ? {'height': '125px'} : {'height': 'initial'}]">
                <div class="sk-circle" id="loading"
                     :style="[autoload ? {'margin': '20px 0'} : {'margin': '100px auto'}]">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>
            <div v-if="!autoload && products.length < dataCount" class="col-lg-12 text-center mb-3 mt-1"
                 @click="getProducts">
                <button class="btn btn-success">نمایش محصولات بیشتر</button>
            </div>

        </div>


        <!-- ------------------------------------------------------------------------------------------->
        <div class="modal fade" id="voucherData" tabindex="-1" role="dialog" aria-labelledby="voucherTitle"
             aria-hidden="true">
            <div class="modal-dialog  modal-dialog-centered" style="max-width: 1140px;" role="document">
                <div class="modal-content" id="printMe">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitle">محصولات فاکتور</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">شماره فاکتور</span>
                            </div>
                            <input class="form-control" type="number" v-model="voucher.voucherNumber"
                                   :placeholder=lastVoucherNumber>
                        </div>
                        <div class="table-responsive">
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th class="text-nowrap">نام محصول</th>
                                    <th class="text-center text-nowrap">تعداد</th>
                                    <th class="text-center text-nowrap">قیمت</th>
                                    <!--<th class="text-center text-nowrap">درصد تخفیف</th>-->
                                    <th class="text-center text-nowrap">تخفیف</th>
                                    <th class="text-center text-nowrap">جمع بعدازتخفیف</th>
                                    <th class="text-center text-nowrap">درصد مالیات</th>
                                    <th class="text-center text-nowrap">مبلغ مالیات</th>
                                    <th class="text-center text-nowrap">جمع</th>
                                    <th class="text-center text-nowrap" v-if="!isProducer">قیمت فروش</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item,index) in cart">
                                    <td class="product-remove-button pb-0"><a class="text-danger"
                                                                              @click="onRemoveProductClicked(index)"><i
                                            class="fa fa-close"></i></a></td>
                                    <td class="text-nowrap mt-2 pb-0">{{item.productName}}</td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 4rem;" type="number"
                                               v-model="item.unitVal">
                                        <small class="text-nowrap mt-2">{{item.unitName}}</small>
                                    </td>
                                    <td class="text-center min-vw-100 pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.price" @input="thousandSeprator(item)">
                                        <small class="text-nowrap mt-2">{{item.priceShow}}</small>
                                    </td>
                                    <!--<td class="text-center pb-0">-->
                                        <!--<input class="form-control" style="min-width: 6rem;" type="number"-->
                                               <!--v-model="item.percent">-->
                                    <!--</td>-->
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.discount">
                                        <small class="text-nowrap mt-2">{{thousandSeprator3(item.discount)}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <span class="form-control" style="min-width: 6rem;">{{((item.price-item.discount) * item.unitVal).toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.taxPercent">
                                        <!--<small class="text-nowrap mt-2">{{item.taxPercent}}</small>-->
                                    </td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number" readonly="true"
                                               v-model="item.taxPrice * item.unitVal">
                                        <!--<small class="text-nowrap mt-2">{{thousandSeprator3(item.taxPrice)}}</small>-->
                                    </td>


                                    <td class="text-center pb-0">
                                        <span class="form-control" style="min-width: 6rem;">{{((item.price-item.discount + item.taxPrice) * item.unitVal).toLocaleString()}}</span>
                                        <input class="form-control" style="min-width: 6rem;" type="number" v-model="item.subPrice" @input="subPriceChange(item)">
                                    </td>
                                    <td class="text-center pb-0" v-if="!isProducer">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.salesPrice" @input="thousandSeprator2(item)">
                                        <small class="text-nowrap mt-2">{{item.salesPriceShow}}</small>
                                    </td>
                                </tr>

                                <tr>
                                    <td colspan="6"></td>
                                </tr>
                                <tr class="bg-total-discount mt-3">
                                    <td colspan="1"></td>
                                    <td class="text-right">
                                        <span>جمع کل : </span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>تعداد کل: </span>-->
                                        <span v-if="isNaN(voucher.overallAmount)" class="text-warning">تعداد به درستی وارد نشده است!</span>
                                        <span v-else>{{voucher.overallAmount}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>قیمت کل: </span>-->
                                        <span v-if="isNaN(voucherNoDiscount)" class="text-warning">مبلغ به درستی وارد نشده است!</span>
                                        <span v-else>{{voucherNoDiscount.toLocaleString()}}</span>
                                    </td>
                                    <td></td>
                                    <td class="text-center">
                                        <!--<span>جمع تخفیف : </span>-->
                                        <span v-if="isNaN(voucher.totalDiscount)" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{voucher.totalDiscount.toLocaleString()}}</span>
                                    </td>
                                    <td></td>

                                    <td class="text-center">
                                        <!--<span>جمع تخفیف : </span>-->
                                        <span v-if="isNaN(vouchertotalTax)" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{(vouchertotalTax).toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>جمع تخفیف : </span>-->
                                        <span v-if="isNaN((voucherNoDiscount - voucher.totalDiscount+ vouchertotalTax))" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{(voucherNoDiscount - voucher.totalDiscount+ vouchertotalTax).toLocaleString()}}</span>
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                            <h4 class="text-center no-item-alert mt-5" v-if="cart.length < 1">محصولی ثبت نشده
                                است!</h4>
                        </div>
                        <div class="row">
                            <div class="input-group mt-2 col-4">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">تخفیف فاکتور</span>
                                </div>
                                <input class="form-control" type="number" v-model="voucherDiscount"
                                       placeholder="تخفیف فاکتور">
                            </div>
                            <div class="input-group mt-2 col-4">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">درصد مالیات فاکتور</span>
                                </div>
                                <input class="form-control" type="number" v-model="vouchertaxPercent"
                                       placeholder="درصد مالیات فاکتور">
                            </div>
                            <div class="input-group mt-2 col-4">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">مبلغ مالیات فاکتور</span>
                                </div>
                                <span class="form-control">{{vouchertaxPrice.toLocaleString()}}</span>
                            </div>
                            <div class="input-group mt-2 col-12">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">توضیحات</span>
                                </div>
                                <input class="form-control" type="text" v-model="voucher.description"
                                       placeholder="توضیحات">
                            </div>
                            <div class="input-group mt-2 col-12">
                                <div class="input-group-prepend " @click="toggleStartDatePicker">
                                    <div class="input-group-text"><span>تاریخ فاکتور :</span></div>
                                </div>
                                <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                             ref="datePickerStart" style="flex: 1">
                                    <slot>
                                        <input v-model="voucherDatePersian" class="form-control date-input" readonly="true"
                                               @click="toggleStartDatePicker">
                                        <button class="close reset-date pr-2" @click="resetStartDate">×</button>
                                    </slot>
                                </date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-lg-6 w-100 text-right">

                                    <div class="row">
                                        <!--<div class="col-md-6">-->
                                        <!--<span>تعداد کل: </span>-->
                                        <!--<span v-if="isNaN(voucher.overallAmount)" class="text-warning">تعداد به درستی وارد نشده است!</span>-->
                                        <!--<span v-else>{{voucher.overallAmount}}</span>-->
                                        <!--&nbsp;&nbsp;&nbsp;-->
                                        <!--</div>-->
                                        <!--<div class="col-md-6">-->
                                        <!--<span>مبلغ کل: </span>-->
                                        <!--<span v-if="isNaN(voucher.overallPrice)" class="text-warning">قیمت خرید به درستی وارد نشده است!</span>-->
                                        <!--<span v-else>{{voucher.overallPrice.toLocaleString()}}</span>-->
                                        <!--</div>-->
                                        <div class="col-12">
                                            <span class="text-bold bg-total-cost p-1">قابل پرداخت: </span>
                                            <span v-if="isNaN(voucher.overallPrice)" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                            <span v-else class="text-bold bg-total-cost p-1">{{voucher.overallPrice.toLocaleString()}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class=" col-lg-6 w-100 text-right d-inline-flex">
                                    <button type="button" class="btn btn-secondary m-1" data-dismiss="modal">بستن
                                    </button>
                                    <button type="button" class="btn btn-primary m-1" @click="onModalOk"
                                            v-if="cart.length > 0 && !fromEdit">بایگانی
                                    </button>
                                    <button type="button" class="btn btn-success m-1" @click="onPaymentClicked"
                                            v-if="cart.length > 0">پرداخت
                                    </button>
                                     <button type="button" class="btn btn-warning m-1" @click="onPishClicked"
                                            v-if="cart.length > 0">پیش فاکتور
                                    </button>
                                    <!--<button type="button" class="d-inline-block btn btn-success m-1"-->
                                    <!--@click="onPrintClicked"><i-->
                                    <!--class="fa fa-print"></i></button>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="voucherDataReturn" tabindex="-1" role="dialog" aria-labelledby="voucherTitleReturn"
             aria-hidden="true">
            <div class="modal-dialog  modal-dialog-centered" style="max-width: 1140px;" role="document">
                <div class="modal-content" id="printMeReturn">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitleReturn">محصولات فاکتور</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <table class="table table-hover table-striped">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th class="text-nowrap">نام محصول</th>
                                    <th class="text-center text-nowrap">تعداد</th>
                                    <th class="text-center text-nowrap">قیمت</th>
                                    <th class="text-center text-nowrap">هزینه مرجوعی</th>
                                    <th class="text-center text-nowrap">جمع</th>
                                    <!--<th class="text-center text-nowrap" v-if="!isProducer">قیمت فروش</th>-->
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item,index) in cart">
                                    <td class="product-remove-button pb-0"><a class="text-danger"
                                                                              @click="onRemoveProductClicked(index)"><i
                                            class="fa fa-close"></i></a></td>
                                    <td class="text-nowrap mt-2 pb-0">{{item.productName}}</td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 4rem;" type="number"
                                               v-model="item.unitVal">
                                        <small class="text-nowrap mt-2">{{item.unitName}}</small>
                                    </td>
                                    <td class="text-center min-vw-100 pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.price" @input="thousandSeprator(item)">
                                        <small class="text-nowrap mt-2">{{item.priceShow}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.discount">
                                        <small class="text-nowrap mt-2">{{thousandSeprator3(item.discount)}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <input class="form-control" style="min-width: 6rem;" type="number"
                                               v-model="item.taxPrice">
                                        <small class="text-nowrap mt-2">{{thousandSeprator3(item.taxPrice)}}</small>
                                    </td>
                                    <td class="text-center pb-0">
                                        <span class="form-control" style="min-width: 6rem;">{{((item.price-item.discount + item.taxPrice) * item.unitVal).toLocaleString()}}</span>
                                    </td>
                                    <!--<td class="text-center pb-0" v-if="!isProducer">-->
                                    <!--<input class="form-control" style="min-width: 6rem;" type="number"-->
                                    <!--v-model="item.salesPrice" @input="thousandSeprator2(item)">-->
                                    <!--<small class="text-nowrap mt-2">{{item.salesPriceShow}}</small>-->
                                    <!--</td>-->
                                </tr>

                                <tr>
                                    <td colspan="6"></td>
                                </tr>
                                <tr class="bg-total-discount mt-3">
                                    <td colspan="1"></td>
                                    <td class="text-right">
                                        <span>جمع کل : </span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>تعداد کل: </span>-->
                                        <span v-if="isNaN(voucher.overallAmount)" class="text-warning">تعداد به درستی وارد نشده است!</span>
                                        <span v-else>{{voucher.overallAmount}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>قیمت کل: </span>-->
                                        <span v-if="isNaN(voucherNoDiscount)" class="text-warning">مبلغ به درستی وارد نشده است!</span>
                                        <span v-else>{{voucherNoDiscount.toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>جمع تخفیف : </span>-->
                                        <span v-if="isNaN(voucher.totalDiscount)" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{voucher.totalDiscount.toLocaleString()}}</span>
                                    </td>
                                    <td class="text-center">
                                        <!--<span>جمع تخفیف : </span>-->
                                        <span v-if="isNaN((voucherNoDiscount - voucher.totalDiscount))" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                        <span v-else>{{(voucherNoDiscount - voucher.totalDiscount).toLocaleString()}}</span>
                                    </td>
                                </tr>

                                </tbody>
                            </table>
                            <h4 class="text-center no-item-alert mt-5" v-if="cart.length < 1">محصولی ثبت نشده
                                است!</h4>
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">هزینه مرجوعی فاکتور</span>
                            </div>
                            <input class="form-control" type="number" v-model="voucherDiscount"
                                   placeholder="هزینه مرجوعی فاکتور">
                        </div>
                        <div class="input-group mt-2">
                            <div class="input-group-prepend">
                                <span class="input-group-text">توضیحات</span>
                            </div>
                            <input class="form-control" type="text" v-model="voucher.description"
                                   placeholder="توضیحات">
                        </div>
                        <!--<div class="input-group mt-2">-->
                        <!--<div class="input-group-prepend " @click="toggleStartDatePicker">-->
                        <!--<div class="input-group-text"><span>تاریخ فاکتور :</span></div>-->
                        <!--</div>-->
                        <!--<date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"-->
                        <!--ref="datePickerStart" style="flex: 1">-->
                        <!--<slot>-->
                        <!--<input v-model="voucherDatePersian" class="form-control date-input" readonly="true"-->
                        <!--@click="toggleStartDatePicker">-->
                        <!--<button class="close reset-date" @click="resetStartDate">×</button>-->
                        <!--</slot>-->
                        <!--</date-picker>-->
                        <!--</div>-->
                    </div>
                    <div class="modal-footer d-block">
                        <div class="container-fluid">
                            <div class="row">
                                <div class="col-lg-6 w-100 text-right">

                                    <div class="row">
                                        <!--<div class="col-md-6">-->
                                        <!--<span>تعداد کل: </span>-->
                                        <!--<span v-if="isNaN(voucher.overallAmount)" class="text-warning">تعداد به درستی وارد نشده است!</span>-->
                                        <!--<span v-else>{{voucher.overallAmount}}</span>-->
                                        <!--&nbsp;&nbsp;&nbsp;-->
                                        <!--</div>-->
                                        <!--<div class="col-md-6">-->
                                        <!--<span>مبلغ کل: </span>-->
                                        <!--<span v-if="isNaN(voucher.overallPrice)" class="text-warning">قیمت خرید به درستی وارد نشده است!</span>-->
                                        <!--<span v-else>{{voucher.overallPrice.toLocaleString()}}</span>-->
                                        <!--</div>-->
                                        <div class="col-12">
                                            <span class="text-bold bg-total-cost p-1">قابل پرداخت: </span>
                                            <span v-if="isNaN(voucher.overallPrice)" class="text-warning">قیمت به درستی وارد نشده است!</span>
                                            <span v-else class="text-bold bg-total-cost p-1">{{voucher.overallPrice.toLocaleString()}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class=" col-lg-6 w-100 text-right d-inline-flex">
                                    <button type="button" class="btn btn-secondary m-1" data-dismiss="modal">بستن
                                    </button>

                                    <button type="button" class="btn btn-success m-1" @click="onPaymentClickedReturn"
                                            v-if="cart.length > 0">دریافت
                                    </button>
                                    <!--<button type="button" class="d-inline-block btn btn-success m-1"-->
                                    <!--@click="onPrintClickedReturn"><i-->
                                    <!--class="fa fa-print"></i></button>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ------------------------------------------------------------------------------------------->
        <div class="modal fade" id="barcodeModal" tabindex="-1" role="dialog" aria-labelledby="voucherTitlebarcode"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitlebarcode">خواندن بارکد
                            محصول</h5>

                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mt-3">
                        <div class="row">
                            <div class="col-12">

                                <StreamBarcodeReader
                                        @decode="(a, b, c) => onDecode(a, b, c)"
                                        @loaded="() => onLoaded()"
                                ></StreamBarcodeReader>
                                <h5 class="col-12 text-center m-3">{{ barcode || "هیچ بارکدی قرائت نشده، لطفا دوربین را روی بارکد بگیرید" }}</h5>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer d-block mt-3">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <!--<button type="button" class="btn btn-danger mr-2" @click="onModalDelete">حذف</button>-->
                        <!--<button type="button" class="btn btn-primary" @click="onModalOk">ذخیره</button>-->
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="productModal" tabindex="-1" role="dialog" aria-labelledby="voucherTitleproduct"
             aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-warning-grad glow-warning">
                        <h5 class="modal-title text-white" id="voucherTitleproduct">ایجاد
                            محصول</h5>

                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body mt-3">
                        <div class="row">
                            <div class="col-lg-9 col-md-12 col-sm-12 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">دسته بندی</span>
                                    </div>
                                    <vs-select :data="categories" :selected-val="preselectedCategory"
                                               :mode="'create'"
                                               :header="{multiple: false, label: 'name'}"
                                               @onChange="onCategoryChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-3 col-md-12 col-sm-12 text-center">
                                <button class="btn btn-primary bg-danger-grad border-0"
                                        @click="onAddCategoryClicked" data-toggle="tooltip" data-placement="bottom"
                                        title="افزودن دسته بندی">افزودن دسته بندی
                                </button>
                            </div>
                            <div class="col-lg-12 mt-3 mt-lg-0">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">نام محصول</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="product.productName">
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">واحد</span>
                                    </div>
                                    <vs-select :data="units" :selected-val="preselectedUnit"
                                               :mode="'create'" :header="{multiple: false, label: 'unitName'}"
                                               @onChange="onUnitChange"></vs-select>
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">بارکد</span>
                                    </div>
                                    <input class="form-control" type="number" v-model="product.barcode">
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">تعداد هشدار کسر موجودی</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="product.lessAmount">
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد فنی</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="product.technicalCode">
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">شناسه مالیاتی</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="product.taxCode">
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">درصد مالیات</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="product.defultTaxPercent">
                                </div>
                            </div>
                            <div class="col-lg-6 mt-3">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">کد محصول</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="product.productCode">
                                </div>
                            </div>

                        </div>

                    </div>
                    <div class="modal-footer d-block mt-3">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onProductModalOk">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="category-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-danger glow-warning">
                        <h5 class="modal-title text-white">افزودن دسته بندی</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row text-center">
                            <div class="col-lg-6 mb-2">
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">عنوان دسته بندی</span>
                                    </div>
                                    <input class="form-control" type="text" v-model="categoryName">
                                </div>
                            </div>
                            <!--<div class="col-lg-6 mb-2">-->
                            <!--<div class="input-group">-->
                            <!--<div class="input-group-prepend">-->
                            <!--<span class="input-group-text">دسته بندی مادر</span>-->
                            <!--</div>-->
                            <!--<vs-select-->
                            <!--:data="categories"-->

                            <!--:mode="'create'"-->
                            <!--:header="{multiple: false, label: 'name'}"-->
                            <!--@onChange="onCategoryChange"-->
                            <!--&gt;</vs-select>-->
                            <!--</div>-->
                            <!--</div>-->
                        </div>
                    </div>
                    <div class="modal-footer d-block">
                        <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal">بستن</button>
                        <button type="button" class="btn btn-primary" @click="onCreateCategory">ذخیره</button>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import * as $ from 'jquery';
    import axios from 'axios';
    import Vue from 'vue';
    import BaseService from "../_framework/api/BaseService";
    import Utils from "../_framework/utils/Utils";
    import EventBus from "../_framework/event-bus.js";
    import VueHtmlToPaper from 'vue-html-to-paper';
    import {StreamBarcodeReader} from "vue-barcode-reader";
    import VsSelect from '../_framework/VsSelect.vue';
    import DatePicker from '../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import Moment from "moment-jalali";

    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    //$(".product-container:nth-child(1)").css("background-color","green");
    $(".voucher-modal-button").click(() => {
        $("#voucherData").modal("show");
    });

    export default {
        name: 'buy-from-outsource',
        components: {
            DatePicker,
            VsSelect,
            StreamBarcodeReader
        },
        data() {
            return {
                barcodeInputTimeout: null,
                isBarcodeScanning: false,
                isModalOpen: false,
                products: [],
                categories: [],
                queryParams: {
                    pageSize: 18000,
                    pageIndex: 0,
                    name: "",
                    // outsourceId: 0,
                    showAll: false
                },
                searchString: "",
                modalProductName: "",
                cart: [],
                voucher: {
                    description: "",
                    serveOutSourceId: 0,
                    voucherProductDto: [],
                    outSourceName: "",
                    overallAmount: 0,
                    overallPrice: 0,
                    taxPercent: 0,
                    taxPrice: 0,
                    discount: 0,
                    voucherDate: "0001-01-01",
                    voucherNumber: null
                },
                voucherDatePersian: "",
                tempVoucher: [],
                outSourceName: "",
                dataCount: 0,

                listView: false,
                autoload: false,

                userId: 0,
                companyId: 0,
                fromEdit: false,
                barcode: "",
                outsourceId: 0,
                categoryName: "",
                preselectedCategory: {},
                product: {
                    productName: "",
                    unitId: 0,
                    barcode: "",
                    categoryId: 0,
                },
                units: [],
                preselectedUnit: {},
                isProducer: false,
                producerMobile: "",
                companyPostName: "",
                voucherDiscount: 0,
                vouchertaxPercent: 0,
                vouchertaxPrice: 0,
                vouchertotalTax: 0,
                overallProductPrice: 0,
                voucherNoDiscount: 0,
                isSending: false,
                lastVoucherNumber:"",
            }
        },
        mounted() {


            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);
            this.userId = localStorage.getItem("userId");
            this.companyId = localStorage.getItem("companyId");

            this.companyPostName = localStorage.getItem("companyPostName");
            if (this.companyPostName === 'تامین کننده') {
                this.isProducer = true;
                this.producerMobile = localStorage.getItem("phoneNumber");
                console.log(this.producerMobile);
            }

            this.autoload = JSON.parse(localStorage.getItem("autoload"));
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            this.outsourceId = this.$route.params.id;
            this.outSourceName = this.$route.params.outSourceName;

            // console.log(this.$route.params.voucher)
            this.fromEdit = this.$route.params.fromEdit;
            new BaseService('product').getList(this.queryParams).then(response => {
                this.products = response.data.data;
                this.dataCount = response.data.count;
                if (this.$route.params.voucher !== undefined) {
                    console.log(this.$route.params.voucher)
                    this.voucher.discount = this.$route.params.voucher.discount;
                    this.voucher.description = this.$route.params.voucher.description;
                    this.voucher.taxPrice =this.$route.params.voucher.taxPrice;
                    this.voucher.taxPercent =this.$route.params.voucher.taxPercent;

                    this.vouchertaxPrice = this.$route.params.voucher.taxPrice;
                    this.vouchertaxPercent= this.$route.params.voucher.taxPercent;
                    this.cart = this.$route.params.voucher.voucherProductDto;
                    this.validateProductsList();
                }
                $("#loading").hide();
            }).catch(error => {
                console.log(error)
                Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
            });
            // new BaseService('outsource').getById(this.$route.params.id).then(response => {
            //     this.outSourceName = response.data.outSourceName;
            // }).catch(error => {
            //     console.log(error)
            //     Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
            // });

            if (localStorage.getItem(`tempVoucherBuy${this.userId}${this.companyId}`) === null) {
                localStorage.setItem(`tempVoucherBuy${this.userId}${this.companyId}`, "[]");
            }

            if (JSON.parse(localStorage.getItem("autoload"))) {
                $(window).on("scroll", () => {
                    if (Utils.onBottomReached() && this.products.length < this.dataCount) {
                        $("#loading").show();
                        this.getProducts();

                    }
                });
            }
            new BaseService('categories').getAll().then(response => {
                this.categories = response.data;
            }).catch(error => {
                // error
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });
            new BaseService('voucher/getlastVoucherNumber/2').getList().then(response => {
                this.lastVoucherNumber = response.data;
                if(this.lastVoucherNumber!==undefined && this.lastVoucherNumber!== null && this.lastVoucherNumber>0){
                    this.lastVoucherNumber ++;
                    this.lastVoucherNumber =  "اگر خالی بگذارید بصورت اتوماتیک " + this.lastVoucherNumber + " وارد میشود";
                }else{
                    this.lastVoucherNumber =100;
                }
            }).catch(error => {
                // error
                this.lastVoucherNumber =100;
                Utils.handleErrorWithNotification(error.message, this.$noty);
            });
            this.getUnits();
            let tod = Moment(new Date()).format('YYYY-MM-DD');
            this.voucherDatePersian = Moment(tod, 'YYYY-MM-DD').format('jDD jMMMM jYYYY');
            this.$refs.searchInput.focus();
        },
        methods: {
            getUnits() {
                new BaseService('units').getAll().then(response => {
                    this.units = response.data;
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                });

            },
            getCategories() {
                new BaseService('categories').getAll().then(response => {
                    this.categories = response.data;
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            getProducts() {
                this.queryParams.pageIndex++;
                $("#loading").show();
                new BaseService('product').getList(this.queryParams).then(response => {
                    this.products.push.apply(this.products, response.data.data);
                    this.validateProductsList();
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });
            },
            onSelectCategory(val) {
                this.queryParams.categoryId = val.id;
                this.queryParams.pageIndex = 0;
                $("#loading").hide();
                new BaseService('product', '/get').getList(this.queryParams).then(response => {
                    // new BaseService('product?pageSize='
                    //     + this.queryParams.pageSize
                    //     + '&pageIndex='
                    //     + this.queryParams.pageIndex
                    //     + '&name='
                    //     + this.queryParams.name
                    //     + '&showAll='
                    //     + this.queryParams.showAll).getList().then(response => {
                    this.products = response.data.data;
                    this.validateProductsList();
                    $("#loading").hide();
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.response.message, this.$noty);
                });

            },
            onSearchInput() {
                if (this.barcodeInputTimeout) {
                    clearTimeout(this.barcodeInputTimeout);
                }
                this.isBarcodeScanning = true;
                this.barcodeInputTimeout = setTimeout(() => {
                    if (this.searchString.length >= 13) {
                        this.queryParams.name = this.searchString;
                        this.queryParams.pageIndex = 0;
                        $("#loading").show();
                        new BaseService('product').getList(this.queryParams).then(response => {
                            this.products = response.data.data;
                            if (this.products.length === 1) {
                                this.$refs.searchInput.select();
                                this.onCardClicked(null, 0);
                            }
                            this.validateProductsList();
                            $("#loading").hide();
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                    } else {
                        this.queryParams.name = this.searchString;

                        this.queryParams.pageIndex = 0;
                        $("#loading").show();
                        new BaseService('product').getList(this.queryParams).then(response => {
                            this.products = response.data.data;
                            if (this.products.length === 1) {
                                this.$refs.searchInput.select();
                                this.onCardClicked(null, 0);
                            }
                            this.validateProductsList();
                            $("#loading").hide();
                        }).catch(error => {
                            // error
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        });
                    }
                    this.isBarcodeScanning = false;
                }, 300);
            },
            validateProductsList() {
                for (let item of this.cart) {
                    for (let product of this.products) {
                        if (item.productName === product.productName) {
                            product.unitVal = item.unitVal;
                            product.price = item.salesPrice;
                            product.productId = item.productId;
                            product.discount = 0;
                            console.log("val", item);
                            if (item.price === undefined || isNaN(item.price) || item.price === null) {
                                item.price = 0;
                            }
                            item.taxPercent = product.defultTaxPercent;
                            item.taxPrice = item.price * item.taxPercent * 0.01;
                            if (item.percent === undefined || isNaN(item.percent) || item.percent === null) {
                                item.percent = 0;
                            }
                        }
                    }
                }
            },
            onCardClicked(e, index) {
                console.log("click", this.products[index]);
                let flag = false;
                let i = 0;
                let offset = 0;
                for (let item of this.cart) {
                    if (item.productName === this.products[index].productName) {
                        flag = true;
                        offset = i;
                    }
                    i++;
                }
                if (flag === false) {
                    this.products[index].unitVal++;
                    Vue.set(this.products[index], "originalPrice", this.products[index].price);
                    Vue.set(this.products[index], "salesPrice", this.products[index].sellPrice);
                    Vue.set(this.products[index], "discount", 0);
                    Vue.set(this.products[index], "percent", 0);
                    Vue.set(this.products[index], "taxPercent", this.products[index].defultTaxPercent);
                    Vue.set(this.products[index], "taxPrice", this.products[index].defultTaxPercent * this.products[index].price);
                    this.products[index].discount = 0;
                    this.cart.push(this.products[index]);
                } else {
                    this.cart[offset].unitVal++;
                    //this.products[index].unitVal++;
                }
            },
            onRemoveProductClicked(index) {
                for (let item of this.products) {
                    if (item.productName === this.cart[index].productName) {
                        /*item.count = 0;*/
                        item.unitVal = 0;
                        item.price = item.originalPrice;
                    }
                }
                this.cart.splice(index, 1);

            },
            onModalShow() {
                if (!this.isBarcodeScanning) {
                    this.voucher.overallPrice = 0;
                    this.voucher.overallAmount = 0;
                    this.voucherNoDiscount = 0;
                    for (var i of this.cart) {
                        i.priceShow = i.price === null ? 0 : i.price.toLocaleString();
                        i.salesPriceShow = i.salesPrice === null ? 0 : i.salesPrice.toLocaleString();
                        if (i.discount === 0 || i.discount === null || isNaN(i.discount)) {
                            i.discount = 0;
                            if (i.percent === 0) {
                            } else {
                                i.discount = (i.price * i.percent) / 100;
                            }
                        } else {
                            i.percent = Math.ceil(((i.discount * 100) / i.price) * 100) / 100;
                        }
                        i.taxPrice = (i.price - i.discount) * i.taxPercent * 0.01;

                        i.subPrice = (i.price - i.discount + i.taxPrice) * i.unitVal;
                        this.voucher.overallPrice += ((i.price - i.discount + i.taxPrice) * i.unitVal);
                        this.voucherNoDiscount += (i.price * i.unitVal);
                        // this.vouchertotalTax += (i.taxPrice * i.unitVal);
                        this.voucher.overallAmount += i.unitVal;
                        // i.percent = Math.ceil(((i.discount * 100) / i.price) * 100) / 100;
                    }
                    if (this.voucher.discount !== undefined || this.voucher.discount !== null || !isNaN(this.voucher.discount)) {
                        this.voucherDiscount = this.voucher.discount;
                    }

                    $("#voucherData").modal("show");
                    $('#voucherData').on('shown.bs.modal', () => {
                        $(document).on('keyup.modal', (e) => this.onModalKeyUp(e));
                    });
                    $('#voucherData').on('hidden.bs.modal', () => {
                        $(document).off('keyup.modal');
                    });
                }
            },
            onModalKeyUp(event) {
                if (event.key === 'Enter') {
                    this.onPaymentClicked();
                }
            },
            onModalOk() {
                if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                    for (let item of this.cart) {
                        item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                        item.price = item.price === null ? 0 : parseInt(item.price);
                        item.salesPrice = item.salesPrice === null ? 0 : parseInt(item.salesPrice);
                        Vue.set(item, "productId", item.id);
                    }
                    if (this.$route.params.voucher !== undefined) {
                        this.voucher = this.$route.params.voucher;
                        this.tempVoucher = JSON.parse(localStorage.getItem(`tempVoucherBuy${this.userId}${this.companyId}`));
                        this.tempVoucher[this.voucher.voucherIndex] = this.voucher;
                        localStorage.setItem(`tempVoucherBuy${this.userId}${this.companyId}`, JSON.stringify(this.tempVoucher));
                    } else {
                        this.voucher.voucherProductDto = this.cart;
                        this.voucher.serveOutSourceId = parseInt(this.outsourceId);
                        this.voucher.outSourceName = this.outSourceName;

                        this.tempVoucher = JSON.parse(localStorage.getItem(`tempVoucherBuy${this.userId}${this.companyId}`));
                        this.tempVoucher.push(this.voucher);
                        localStorage.setItem(`tempVoucherBuy${this.userId}${this.companyId}`, JSON.stringify(this.tempVoucher));
                    }

                    $("#voucherData").modal("hide");
                    this.isModalOpen = false;
                    window.removeEventListener('keyup', this.onModalKeyUp);
                    this.$noty.info("فاکتور ذخیره شد. برای تکمیل عملیات به بخش بایگانی، فاکتورهای بایگانی شده مراجعه کنید.");
                    for (let item of this.products) {
                        item.unitVal = 0;
                        item.price = item.originalPrice;
                    }
                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }
                /*new BaseService('voucher').create(this.voucher).then(response => {
                    this.$noty.success("موفقیت آمیز!");
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.data.message, this.$noty);
                })*/
            },
            onPishClicked() {
                if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                    for (let item of this.cart) {
                        item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                        item.salesPrice = item.salesPrice === null ? 0 : parseInt(item.salesPrice);
                        item.price = item.price === null ? 0 : parseInt(item.price);
                        item.sellPrice = item.salesPrice;
                        Vue.set(item, "productId", item.id);
                    }
                    this.voucher.voucherProductDto = this.cart;
                    this.voucher.serveOutSourceId = parseInt(this.outsourceId);
                    this.voucher.outSourceName = this.outSourceName;
                    this.voucher.description = "پیش فاکتور " + this.voucher.description;
                    // console.log(this.voucher)
                    $("#voucherData").modal("hide");
                    this.isModalOpen = false;
                    window.removeEventListener('keyup', this.onModalKeyUp);
                    new BaseService('voucher').create(this.voucher).then(response => {
                        let voucherId = response.data.data;
                        new BaseService('voucher', `/payment/${voucherId}`).create(this.payments).then(response => {
                            this.$noty.success('پیش فاکتور با موفقیت ثبت شد');
                            // this.$noty.success("سند با موفقیت ثبت شد!");

                            this.$router.push({name: 'home'});
                        }).catch(error => {
                            this.isPaying = false;
                            this.$noty.error(error.response.message);
                            Utils.handleErrorWithNotification(error.response.message, this.$noty);
                        })
                        this.$router.push(obj);
                    }).catch(error => {
                        this.$noty.error(error);
                        Utils.handleErrorWithNotification(error.response.message, this.$noty);
                    });
                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }
            },
            onPaymentClicked() {
                if (this.$route.params.fromEdit) {
                    if (confirm("در صورت تایید اطلاعات قبلی پرداخت خرید و کالاهای آن حذف میشوند و اطلاعات جدید جایگزین میشوند. آیا از پرداخت اطمینان دارید؟")) {
                        if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                            new BaseService('Voucher', `/DeleteVoucher/${this.$route.params.voucher.id}`).create().then(response => {

                                for (let item of this.cart) {
                                    item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                                    item.salesPrice = item.salesPrice === null ? 0 : parseInt(item.salesPrice);
                                    item.price = item.price === null ? 0 : parseInt(item.price);
                                    item.sellPrice = item.salesPrice;
                                    Vue.set(item, "productId", item.productId);
                                }
                                this.voucher.voucherProductDto = this.cart;
                                this.voucher.serveOutSourceId = parseInt(this.outsourceId);
                                this.voucher.outSourceName = this.outSourceName;
                                $("#voucherData").modal("hide");
                                this.isModalOpen = false;
                                window.removeEventListener('keyup', this.onModalKeyUp);
                                let obj = {
                                    name: 'payment',
                                    params: {
                                        voucher: this.voucher,
                                        type: "buy"
                                    }
                                };
                                this.$router.push(obj);
                            }).catch(error => {
                                console.log(error)
                                Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                            });


                        } else {
                            this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                        }
                    }
                } else {
                    if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                        for (let item of this.cart) {
                            item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                            item.salesPrice = item.salesPrice === null ? 0 : parseInt(item.salesPrice);
                            item.price = item.price === null ? 0 : parseInt(item.price);
                            item.sellPrice = item.salesPrice;
                            Vue.set(item, "productId", item.id);
                        }
                        this.voucher.voucherProductDto = this.cart;
                        this.voucher.serveOutSourceId = parseInt(this.outsourceId);
                        this.voucher.outSourceName = this.outSourceName;
                        // console.log(this.voucher)
                        $("#voucherData").modal("hide");
                        this.isModalOpen = false;
                        window.removeEventListener('keyup', this.onModalKeyUp);
                        let obj = {
                            name: 'payment',
                            params: {
                                voucher: this.voucher,
                                type: "buy"
                            }
                        };
                        this.$router.push(obj);
                    } else {
                        this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                    }
                }
            },
            onPaymentClickedReturn() {

                if (!isNaN(this.voucher.overallPrice) && !isNaN(this.voucher.overallAmount)) {
                    for (let item of this.cart) {
                        item.unitVal = item.unitVal === null ? 0 : parseFloat(item.unitVal);
                        item.salesPrice = item.salesPrice === null ? 0 : parseInt(item.salesPrice);
                        item.price = item.price === null ? 0 : parseInt(item.price);
                        item.sellPrice = item.salesPrice;
                        Vue.set(item, "productId", item.id);
                    }
                    this.voucher.voucherProductDto = this.cart;
                    this.voucher.serveOutSourceId = parseInt(this.outsourceId);
                    this.voucher.outSourceName = this.outSourceName;
                    // console.log(this.voucher)
                    $("#voucherDataReturn").modal("hide");
                    let obj = {
                        name: 'payment',
                        params: {
                            voucher: this.voucher,
                            type: "buy",
                            buyReturn: true
                        }
                    };
                    this.$router.push(obj);
                } else {
                    this.$noty.warning('قیمت یا تعداد محصولات به درستی وارد نشده است!');
                }

            },
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },
            onPrintClickedReturn() {
                this.$htmlToPaper('printMeReturn');
            },
            calculateOverallAmount() {
                let amount = 0;
                for (let item of this.cart) {
                    amount += parseFloat(item.unitVal);
                }
                this.voucher.overallAmount = amount;
            },
            calculateOverallPrice() {
                let price = 0;
                let discount = 0;
                let totalTax = 0;
                console.log("discount on row change")
                for (let item of this.cart) {
                    price += (parseFloat(item.unitVal) * parseInt(item.price));
                    if (item.discount === 0 || item.discount === null || isNaN(item.discount)) {
                        item.discount = 0;
                        if (item.percent === 0) {

                        } else {
                            item.discount = (item.price * item.percent) / 100;
                        }
                    } else {
                        item.percent = Math.ceil(((item.discount * 100) / item.price) * 100) / 100;

                    }
                    item.taxPrice = (item.price - item.discount) * item.taxPercent * 0.01;
                    // item.subPrice = (item.price-item.discount) * item.unitVal;
                    discount += (parseFloat(item.unitVal) * parseInt(item.discount));
                    totalTax += (parseFloat(item.unitVal) * parseInt(item.taxPrice));
                }
                this.voucherNoDiscount = price;
                this.vouchertotalTax = totalTax;
                this.voucher.totalDiscount = discount;
                this.voucher.totalTax = totalTax;
                this.overallProductPrice = price - discount + totalTax;


                this.vouchertaxPrice = this.voucher.taxPercent * 0.01 * (this.overallProductPrice - this.voucherDiscount);
                this.voucher.taxPrice = this.vouchertaxPrice;
                this.voucher.overallPrice = this.overallProductPrice - this.voucherDiscount + this.voucher.taxPrice;
            },
            subPriceChange(item) {
                item.price = (item.subPrice / item.unitVal) + item.discount;
            },
            onReturn() {
                if (this.fromEdit) {
                    if (confirm("در صورت تایید اطلاعات پرداخت خرید و کالاهای آن حذف میشوند. آیا مرجوعی را تایید میکنید؟")) {
                        new BaseService('Voucher', `/DeleteVoucher/${this.$route.params.voucher.id}`).create().then(response => {


                            let obj = {
                                name: 'home',

                            };
                            this.$router.push(obj);
                        }).catch(error => {
                            console.log(error)
                            Utils.handleErrorWithNotification(error.response.data.message, this.$noty);
                        });
                    }
                } else {
                    for (let i of this.cart) {
                        i.priceShow = i.price === null ? 0 : i.price.toLocaleString();
                        i.salesPriceShow = i.salesPrice === null ? 0 : i.salesPrice.toLocaleString();
                    }
                    $("#voucherDataReturn").modal("show");
                }
            },
            onDecode(a, b, c) {
                console.log(a, b, c);
                this.barcode = a;
                this.searchString = a;
                this.onSearchInput();
                $("#barcodeModal").modal("hide");
                // if (this.id) clearTimeout(this.id);
                // this.id = setTimeout(() => {
                //     if (this.text === a) {
                //         this.text = "";
                //     }
                // }, 5000);
            },
            onLoaded() {
                console.log("load");
            },
            openBarcode() {
                this.barcode = "";
                $("#barcodeModal").modal("show");
            },
            thousandSeprator(a) {

                let amount = a.price;
                let showprice = "";

                if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                a.priceShow = showprice;

            },
            thousandSeprator2(a) {

                let amount = a.salesPrice;
                let showprice = "";

                if (amount !== '' && amount !== undefined && amount !== 0 && amount !== '0' && amount !== null) {
                    showprice = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                    showprice = amount;
                }
                a.salesPriceShow = showprice;
                return a;
            },
            onModalButtonClick() {
                $("#productModal").modal("show");
                let na = this.product.productName;
                this.product = {};
                if (this.preselectedUnit.id !== null) {
                    this.product.unitId = this.preselectedUnit.id;
                }
                if (this.preselectedCategory.id !== null) {
                    this.product.categoryId = this.preselectedCategory.id;
                }
                if (na !== null && na !== '') {
                    this.product.productName = na;
                }
            },
            onCategoryChange(e) {
                if (e && e.id != null) {
                    this.preselectedCategory = e;
                    this.product.categoryId = e.id;
                }
            },
            onAddCategoryClicked() {
                $("#category-modal").modal("show");
                // this.$router.push({name: 'category'});
            },
            onUnitChange(e) {
                if (e && e.id != null) {
                    this.preselectedUnit = e;
                    this.product.unitId = e.id;
                }
            },
            onProductModalOk() {
                this.onCreateProduct(this.product);
            },
            onCreateProduct(product) {
                if (!this.isSending) {
                    this.isSending = true;
                    console.log(product)
                    if (product.categoryId === undefined || product.categoryId === null) {
                        Utils.handleErrorWithNotification("لطفا دسته بندی را انتخاب کنید", this.$noty);
                    } else if (product.unitId === undefined || product.unitId === null) {
                        Utils.handleErrorWithNotification("لطفا واحد را انتخاب کنید", this.$noty);
                    } else {
                        product.rowVersion = this.generateUuid();
                        new BaseService('product').create(product).then(response => {
                            this.$noty.success("موفقیت آمیز!");
                            $("#productModal").modal("hide");
                            this.queryParams.pageIndex = 0;
                            new BaseService('product', '/get').getList(this.queryParams).then(response => {
                                this.products = response.data.data;
                                $("#loading").hide();
                            }).catch(error => {
                                // error
                                Utils.handleErrorWithNotification(error.data.messages, this.$noty);
                            });
                            this.isSending = false;
                        }).catch(error => {
                            this.isSending = false;
                            Utils.handleErrorWithNotification(error.data.message, this.$noty);
                            Utils.handleErrorWithNotification(error.data.errors[0].message, this.$noty);
                        })
                    }
                }
            },
            onCreateCategory() {
                if (!this.isSending) {
                    this.isSending = true;
                    let category = {
                        name: this.categoryName,
                        companyId: parseInt(localStorage.getItem("companyId")),
                        id: 0,
                        // parentCategoryId: this.parentCategoryId
                    };
                    category.rowVersion = this.generateUuid();
                    new BaseService('categories').create(category).then(response => {
                        this.$noty.success("دسته بندی با موفقیت افزوده شد.");
                        $("#category-modal").modal("hide");
                        this.queryParams.pageIndex = 0;
                        this.getCategories();
                        this.isSending = false;
                    }).catch(error => {
                        this.isSending = false;
                        Utils.handleErrorWithNotification(error.data.message, this.$noty);
                    });
                }
            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            onStartDatePicked(val) {
                this.voucher.voucherDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.voucherDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            resetStartDate() {
                this.voucher.voucherDate = "0001-01-01";
                this.voucherDatePersian = '';
            },


        },
        beforeRouteLeave(to, from, next) {
            $(window).unbind('scroll');
            if ($("#voucherData").hasClass("show")) {
                $("#voucherData").modal("hide");
                this.isModalOpen = false;
                window.removeEventListener('keyup', this.onModalKeyUp);
                next(false);
            } else {
                next();
            }
        },
        watch: {
            cart: {
                handler(val) {
                    this.calculateOverallAmount();
                    this.calculateOverallPrice();
                },
                deep: true
            },
            voucherDiscount(val) {
                this.voucher.discount = val;
                this.calculateOverallPrice();
            },
            vouchertaxPercent(val) {
                this.voucher.taxPercent = val;
                this.calculateOverallPrice();
            }
        }
    }
</script>
<style>
    @media (max-width: 991px) {
        .barcode {
            display: block !important;
        }
    }

    @media (min-width: 990px) {
        .barcode {
            display: none !important;
        }
    }
</style>